module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('strong', [_c('em', [_vm._v("Contents")])])])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/006_Seriespreface#fm-1"
    }
  }, [_c('em', [_vm._v("Series Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Authorspreface#fm-2"
    }
  }, [_c('em', [_vm._v("Author’s Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Abbreviations#fm-3"
    }
  }, [_c('em', [_vm._v("Abbreviations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Bibliography#fm-4"
    }
  }, [_c('em', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#ch-1"
    }
  }, [_c('strong', [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "1.3em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec-1"
    }
  }, [_vm._v("I. RIVERS, ROADS, ROLLING MOUNTAINS, AND THE SEA: GEOGRAPHY AND TRAVEL THROUGH MACEDONIA AND THESSALONICA")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "1em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec-2"
    }
  }, [_vm._v("II. A SUMMARY HISTORY OF MACEDONIA AND THESSALONICA")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "0.6em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec-3"
    }
  }, [_vm._v("III. THE GOVERNMENT OF THESSALONICA")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "0.66em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec-4"
    }
  }, [_vm._v("IV. THE SOCIAL AND ECONOMIC WORLDS OF THESSALONICA")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "1.1em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec-5"
    }
  }, [_vm._v("V. RELIGION IN THESSALONICA")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "0.6em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec-6"
    }
  }, [_vm._v("VI. THE GOSPEL AND THE THESSALONIANS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "0.3em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec-7"
    }
  }, [_vm._v("VII. THE AUTHORSHIP OF 1 AND 2 THESSALONIANS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-1"
    }
  }, [_vm._v("A. 1 Thessalonians")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-2"
    }
  }, [_vm._v("B. 2 Thessalonians")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec3-1"
    }
  }, [_c('em', [_vm._v("1. Literary Arguments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec3-2"
    }
  }, [_c('em', [_vm._v("2. The Argument from Form")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec3-3"
    }
  }, [_c('em', [_vm._v("3. The Theological Argument")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec-8"
    }
  }, [_vm._v("VIII. THE ORDER OF THE EPISTLES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "0.7em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec-9"
    }
  }, [_vm._v("IX. THE STRUCTURE OF 1 AND 2 THESSALONIANS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/011_Chapter02#ch-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 THESSALONIANS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "1.3em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter02#sec-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I. “PAUL, SILAS AND TIMOTHY, TO THE CHURCH OF THE THESSALONIANS” — THE EPISTOLARY GREETING (1.1)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "1em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter02#sec-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II. “WE ALWAYS THANK GOD FOR ALL OF YOU” — THE COMING OF THE GOSPEL AND ITS RECEPTION (1.2-10)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "0.6em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter02#sec-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III. “YOU KNOW …” — THE BODY OF THE LETTER (2.1–5.22)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter02#sec2-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. “Our visit to you was not a failure” — The Gospel Arrives in Thessalonica (2.1–3.13)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter02#sec3-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("1. “ Our visit” — The Apostolic Entrance (2.1-12)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter02#sec3-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("2. “We also thank God … you received the word of God” — The Reception of the Gospel (2.13-16)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter02#sec3-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("3. “We were torn away from you” — The Exit of the Apostles and the Attempts to Return (2.17-20)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter02#sec3-7",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("4. “We sent Timothy” — The Mission of Timothy (3.1-5)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter02#sec3-8",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("5. “But Timothy has just now come to us” — Thanksgiving to God for the Thessalonians (3.6-10)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter02#sec3-9",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("6. “Now may our God … clear the way for us to come to you” — The Prayer to Return to Thessalonica (3.11-13)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec2-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. “You know what instructions we gave you” — The Life That Pleases God (4.1–5.22)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec3-10",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("1. “We instructed you how to live in order to please God” — The Introduction (4.1-2)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec3-11",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("2. “You should avoid sexual immorality” — Sanctification (4.3-8)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec3-12",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("3. “Now about …” — Responses to Questions (4.9–5.11)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec4-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. Fraternal “love” (4.9-12)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec4-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. “Those who fall asleep” (4.13-18)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec4-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c. “Times and dates” (5.1-11)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec3-13",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("4. “Respect those who work hard among you” — The Community and Its Leadership (5.12-13)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec3-14",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("5. “Warn … encourage … help … be patient” — Life in Community (5.14)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec3-15",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("6. “Make sure that nobody pays back wrong for wrong” — The Life of Nonretaliation (5.15)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec3-16",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("7. “Be joyful … pray … give thanks” — Communion with God (5.16-18)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec3-17",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("8. “Do not put out the Spirit’s fire” — Prophecy in the Community (5.19-22)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "0.66em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter02#sec-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV. “MAY GOD HIMSELF” — THE FINAL PRAYER, GREETINGS, AND BLESSING (5.23-28)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter02#sec2-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. “May God … sanctify you through and through” (5.23-25)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter02#sec2-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. “Greet all the brothers and sisters” (5.26-27)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter02#sec2-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. “The grace of our Lord Jesus Christ be with you” (5.28)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("2 THESSALONIANS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "1.3em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I. “PAUL, SILVANUS, AND TIMOTHY, TO THE CHURCH OF THE THESSALONIANS” — THE EPISTOLARY SALUTATION (1.1-2)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "1em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II. “YOUR FAITH IS GROWING AND YOUR LOVE IS INCREASING” — THANKSGIVING AND PRAYERS FOR THE FAITH, LOVE, AND STEADFASTNESS OF THE PERSECUTED THESSALONIANS (1.3-12)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec2-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. “We must always give thanks to God for you” — The First Thanksgiving (1.3-5)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec2-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. “It is indeed just of God to repay with affliction those who afflict you” — The Destiny of the Persecutors (1.6-10)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec2-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. “To this end we will always pray for you” — The Remembrance of Prayers to Be Worthy of God’s Call (1.11-12)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "0.6em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III. “AS TO …” — THE BODY OF THE LETTER (2.1–3.15)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec2-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. “As to the coming of our Lord Jesus Christ” — The Time of the Day of the Lord (2.1-17)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec3-18",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("1. Do not “be quickly shaken” — False Teaching about the Day of the Lord (2.1-12)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec3-19",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("2. “But we must always give thanks to God for you” — The Second Thanksgiving (2.13-14)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec3-20",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("3. “Stand firm and hold fast to the traditions” — Exhortation to Steadfastness — 2.15")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec3-21",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("4. “Now may our Lord Jesus Christ himself and God our Father” — The First Prayer (2.16-17)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec2-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. “Finally, brothers and sisters” — Final Instructions (3.1-15)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec3-22",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("1. “Pray for us” — Mutual Prayers (3.1-5)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec4-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. “So that the word of the Lord may spread rapidly” — The Prayer Request of the Apostles (3.1-2)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec4-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. “But the Lord is faithful; he will strengthen you” — Confidence in the Lord (3.3-4)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec4-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c. “May the Lord direct your hearts to the love of God” — The Second Prayer (3.5)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec3-23",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("2. “Now we command you” — The Problem of the Disorderly (3.6-15)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec4-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. “Keep away from believers who are living in idleness” — The First Exhortation (to the Community) (3.6)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec4-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. “We were not idle when we were with you” — The Example of the Apostles (3.7-10)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec4-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c. “Work quietly and earn your own living” — The Second Exhortation (to the Disorderly) (3.11-12)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec4-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("d. “Do not be weary in doing what is right” — The Third Exhortation (to the Community) (3.13)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec4-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("e. “Take note of those who do not obey” — Discipline in the Community (3.14-15)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "0.66em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV. “NOW MAY THE LORD OF PEACE HIMSELF GIVE YOU PEACE” — THE THIRD PRAYER AND FINAL GREETINGS (3.16-18)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec2-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. “Now may the Lord of peace himself give you peace” — The First Benediction (3.16)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec2-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. “I, Paul, write this greeting” — The Apostolic Greeting and Guarantee (3.17)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec2-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. “The grace of our Lord Jesus Christ be with you all” — The Final Benediction (3.18)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb0fd014","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005_Contents.vue
// module id = 69
// module chunks = 0